import { call, put, select, takeLatest } from 'redux-saga/effects';

import {
  submitForm,
  submitFormError,
  submitFormSuccess
} from '../slices/reportForm';
import { RootState } from '../store';
import reportLegacyConection, {
  ReportLegacyConectionArgs
} from './fetchers/reportLegacyConection';

export function* reportWorker() {
  try {
    const values: ReportLegacyConectionArgs = yield select(
      (state: RootState) => ({
        name: state.user.name.value,
        email: state.user.email.value,
        reason: state.reportForm.reason,
        details: state.reportForm.details,
        propertyId: state.reportForm.propertyId
      })
    );
    yield call(reportLegacyConection, values);
    yield put(submitFormSuccess());
  } catch (e) {
    yield put(submitFormError());
  }
}

export default function* watchSubmitReportForm() {
  yield takeLatest(submitForm, reportWorker);
}
